/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Label_Approved_AtInputs */

const vi_sl_detail_label_approved_at = /** @type {(inputs: Sl_Detail_Label_Approved_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời điểm duyệt`)
};

/**

* @param {Sl_Detail_Label_Approved_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_label_approved_at = /** @type {((inputs?: Sl_Detail_Label_Approved_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Label_Approved_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_label_approved_at(inputs)
});